export type BasePatternType = 'ALL' | 'ONLY'

export interface BasePatternTypeItem {
  i18n: string
  value: 0 | 1
}

export function buildPatternTypeConfig(
  allStringId: string,
  onlyStringId: string
): Record<BasePatternType, BasePatternTypeItem> {
  return {
    ALL: {
      i18n: allStringId,
      value: 0
    },
    ONLY: {
      i18n: onlyStringId,
      value: 1
    }
  }
}
